import { Router } from '@angular/router';
import { Component } from '@angular/core';
import { Http, Headers, RequestOptions, Response } from '@angular/http';
import { AppSettings } from '../../common/app.settings';
import { AuthenticationService } from '../../services/authentication.service';
import { DeviceService } from '../../services//device.service';
import { DeviceModel } from '../../models/device.model';

@Component({
    selector: 'devices-history',
    templateUrl: './devices-history.component.html'
})
export class DevicesHistoryComponent {
    deviceList: Array<DeviceModel>;
    isDataAvailable = false;

    constructor(private http: Http, private authService: AuthenticationService, private deviceService: DeviceService) {
    }

    ngOnInit() {
        let headers = new Headers({ 'Authorization': 'Bearer ' + this.authService.token });
        let options = new RequestOptions({ headers: headers });
 
        this.deviceService.getDevices()
        .subscribe(devices => {
            this.deviceList = devices.data;
            for (let device of this.deviceList) {
                device.checked = device.value == "0" ? false : true;
            }
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/components/devices-history/devices-history.component.ts